<!--
 * @Author: zhangguoliang
 * @Date: 2022-11-10 18:57:51
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2022-12-09 14:12:39
-->
<template>
  <a-layout-footer class="footer">
    <div>
      <img
        :src="require('@/assets/images/common/info.png')"
        style="margin-right: 5px"
      />联系我们
    </div>
    <div>
      <span>客服电话：400-0311-616</span>
      <span
        >COPYRIGHT © 2019.河北宏筑建通信息技术有限公司 ALL RIGHTS
        RESERVED.</span
      >
    </div>
    <div>
      <span>商业沟通：HZJT@HEBZTB.COM</span>
      <span
        ><a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          style="color: #fff"
          >冀ICP备18005551号-3</a
        ></span
      >
    </div>
    <div>
      <span>办公时间：09:00 - 11:30 14:00 - 17:30</span>
      <span>
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13010402002288"
          target="_blank"
          style="color: #fff"
        >
          <img src="@/assets/images/common/beian.png" style="width: 18px" />
          冀公网安备13010402002288号
        </a>
      </span>
    </div>
    <div>
      <span>办公地址：河北省石家庄市桥西区新华路296号</span>
    </div>
  </a-layout-footer>
</template>

<style lang="less" scoped>
.footer {
  background: #252934;
  padding: 80px calc(50% - 650px);
  line-height: 20px;
  color: #ffffff;
  & > div:nth-child(n + 2) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
    padding-left: 21px;
    span:nth-child(2) {
      width: 500px;
    }
  }
}
</style>
